export enum ViewType {
  TABLE = "table",
  GRID = "grid",
}
